__webpack_require__.p = "https://bundle.stayforlong.com/20260206.1/_next/";